import React from 'react';
import Weather from "../Images/weather1.png";
import Pink from "../Images/pink.png";
import Business from "../Images/Business.png";
import Dru from "../Images/Dru.PNG"
import "./Websites.css"

function Websites() {
  return (
    <div className="websites">
      <div className="websites-container">
        <div className="website-project">
          <img src={Weather} alt="weather app"/>
          <h3>Weather App</h3>
          <p>
            Used to assist the user to get real-time weather forecast of
            different cities.
          </p>
          <button>
            <a href="https://drusilla-weather-app.vercel.app/" rel="noreferrer" target="_blank">View Project</a>
          </button>
        </div>
        <div className="website-project">
          <img src={Pink} alt="Agatha's Blog"/>
          <h3>Agatha Blog Website</h3>
          <p>
            <em>Still in progress</em>This is a personal blog website that has 3 pages.
          </p>
          <button>
            <a href="https://agathasblog.vercel.app/" rel="noreferrer" target="_blank">View Project</a>
          </button>
        </div>
        <div className="website-project">
          <img src="https://images.pexels.com/photos/389818/pexels-photo-389818.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"alt="Deborah"/>
          <h3>Debz's Portfolio</h3>
          <p>
            This is a portfolio for someone in the virtual assistance and Accounting field
          </p>
           <button>
            <a href="https://debrah.vercel.app/" rel="noreferrer" target="_blank">View Project</a>
          </button>
        </div>
      </div>
      <div className="websites-container">
        <div className="website-project">
          <img src="https://images.pexels.com/photos/158398/niagara-falls-waterfall-horseshoe-158398.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="weather app"/>
          <h3>Georkings World Tour</h3>
          <p>
            A website for a business poating jobs abroad and looking to venture into tours
          </p>
          <button>
            <a href="https://georkingsworldtours.co.ke" rel="noreferrer" target="_blank">View Project</a>
          </button>
        </div>
        <div className="website-project">
          <img src={Dru} alt="weather app"/>
          <h3>My first portfolio</h3>
          <p>
            This was my first portfolio, I built with react and bootstrap.
          </p>
          <button>
            <a href="https://drusillasportfolio.vercel.app/" rel="noreferrer" target="_blank">View Project</a>
          </button>
        </div>
        <div className="website-project">
          <img src={Business} alt="business card"/>
          <h3>Business Card</h3>
          <p>
            This is a business card page used to add a personal touch when interacting.
          </p>
          <button>
            <a href="https://business-card-three-rho.vercel.app/" rel="noreferrer" target="_blank">View Project</a>
          </button>
        </div>
      </div>
    </div>
  )
}

export default Websites